(function(angular, module) {var activityReportStates, resolveActivityTypes, resovleMentoringTypes;

activityReportStates = function($stateProvider, TagUrl, moment) {
  'ngInject';
  var currentYear, participantUrl, programUrl;
  currentYear = moment().year().toString();
  programUrl = new TagUrl().addTagTypes(['program', 'location', 'participant']).setTagDefault('affiliation', 'all').setTagDefault('year', currentYear);
  participantUrl = new TagUrl().addTagTypes(['participant']).setTagDefault('year', currentYear);
  $stateProvider.state('reports.activity', {
    url: programUrl.buildUrl('/activities'),
    params: programUrl.params,
    data: {
      tagUrl: programUrl
    },
    templateUrl: 'reports/activity/base',
    defaultChild: 'reports.activity.overview',
    controller: 'ActivityReportBaseController',
    controllerAs: '$ctrl',
    reloadOnSearch: false,
    resolve: {
      activityTypes: resolveActivityTypes,
      program: function() {
        return null;
      }
    }
  });
  $stateProvider.state('reports.activity.overview', {
    url: '',
    templateUrl: 'reports/activity/overview',
    controller: 'ActivityOverviewController',
    controllerAs: '$ctrl',
    reloadOnSearch: false
  });
  $stateProvider.state('reports.activity.details', {
    url: '/{type}?{page}&{sort}',
    params: {
      page: {
        type: 'int',
        value: 1,
        squash: true
      },
      sort: {
        value: 'name',
        squash: true
      }
    },
    templateUrl: 'reports/activity/details',
    controller: 'ActivityDetailsController',
    controllerAs: '$ctrl',
    reloadOnSearch: false,
    resolve: {
      mentoringTypes: resovleMentoringTypes
    }
  });
  $stateProvider.state('program.reports.activity', {
    url: participantUrl.buildUrl('/activities'),
    params: participantUrl.params,
    data: {
      tagUrl: participantUrl
    },
    templateUrl: 'reports/activity/base',
    defaultChild: 'program.reports.activity.overview',
    controller: 'ActivityReportBaseController',
    controllerAs: '$ctrl',
    reloadOnSearch: false,
    resolve: {
      activityTypes: resolveActivityTypes
    }
  });
  $stateProvider.state('program.reports.activity.overview', {
    url: '',
    templateUrl: 'reports/activity/overview',
    controller: 'ActivityOverviewController',
    controllerAs: '$ctrl',
    reloadOnSearch: false
  });
  $stateProvider.state('program.reports.activity.details', {
    url: '/{type}?{page}&{sort}',
    params: {
      page: {
        type: 'int',
        value: 1,
        squash: true
      },
      sort: {
        value: 'name',
        squash: true
      }
    },
    templateUrl: 'reports/activity/programDetails',
    controller: 'ActivityDetailsController',
    controllerAs: '$ctrl',
    reloadOnSearch: false,
    resolve: {
      mentoringTypes: resovleMentoringTypes
    }
  });
};

resolveActivityTypes = function(ModelConfig) {
  'ngInject';
  return ModelConfig.getOptions('activity_type');
};

resovleMentoringTypes = function(ModelConfig) {
  'ngInject';
  var types;
  types = angular.copy(ModelConfig.getOptions('mentoring_type'));
  Array.prototype.push.call(types, 'amc_mentor');
  types.amc_mentor = 'AmC Mentor';
  return types;
};

module.config(activityReportStates);
})(angular, angular.module("dybReportActivity"));